module.exports = __webpack_public_path__ + "static/media/expii_illo2_v2.13dfd8ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/homepage/expii_illo2_v2.png
// module id = 868
// module chunks = 21